/**
 * Layout pour les pages d'authentification
 */

import { Outlet, Link } from 'react-router-dom';
import { APP_NAME } from '../../shared/utils/appConfig';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col">
      {/* Header simple */}
      <header className="py-4 px-6 bg-surface border-b border-border shadow-sm">
        <div className="max-w-7xl mx-auto flex items-center justify-between">
          <Link to="/" className="text-xl font-bold text-primary">
           {APP_NAME}
          </Link>
          <nav className="flex items-center gap-4">
            <Link
              to="/auth/login"
              className="text-content-muted hover:text-primary"
            >
              Connexion
            </Link>
            <Link
              to="/auth/register"
              className="px-4 py-2 bg-primary text-content-inverted rounded-md hover:bg-primary-dark"
            >
              S'inscrire
            </Link>
          </nav>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1">
        <Outlet />
      </main>

      {/* Footer */}
      <footer className="py-4 px-6 bg-surface border-t border-border">
        <div className="max-w-7xl mx-auto text-center text-sm text-content-muted">
          &copy; {new Date().getFullYear()} {APP_NAME}. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
}

export default AuthLayout;
